<template>
    <div>
      <div class="col-md-12">
        <label for="tz-select" class="form-control-label"
          >Select timezone</label
        >
        <UIDropdown name="tz-select" id="tz-select" :modelValue="timezone" @input="handleTimezoneChange" :values="timezones" />
      </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { minimalTimezoneSet } from 'compact-timezone-list';
import UIDropdown from "@/components/UIDropdown.vue";

export default defineComponent({
    name: 'TimezonePickerComponent',
    components: {
        UIDropdown
    },
    data() {
        return {
            timezone: this.$store.state.activeReportingTimezone.label || this.$store.state.activeReportingTimezone,
            date: null,
            result: null,
            timezones: null,
            interval: null,
            defaultTZ: {
                label: "(GMT+00:00) UTC",
                offset: "+00:00",
                tzCode: "UTC"
            }

        }
    },
    watch: {
        '$store.state.activeReportingTimezone': {
            deep: true,
            handler() {
                const next = this.labelForStoredTimezone();
                if (next && next !== this.timezone) this.timezone = next;
            },
        },
    },
    mounted: function(){
        const timezoneOutput = [
            this.defaultTZ.label
        ];
        minimalTimezoneSet.forEach((tz) => timezoneOutput.push(tz.label));
        this.timezones = timezoneOutput;
        this.timezone = this.labelForStoredTimezone();
    },
    unmounted: function(){
        clearInterval(this.interval);
    },
    methods:{
        labelForStoredTimezone() {
            const stored = this.$store.state.activeReportingTimezone;
            const offset = stored && stored.offset;
            const label = stored && stored.label;
            if (label && offset && String(label).includes(`GMT${offset}`)) return label;
            if (offset === '+00:00' || offset === '00:00') return this.defaultTZ.label;
            const match = minimalTimezoneSet.find((tz) => tz.offset === offset);
            return (match && match.label) || label || this.defaultTZ.label;
        },
        handleTimezoneChange(event){
            this.timezone = event;
            const selected = minimalTimezoneSet.filter((tz) => tz.label == event);
            this.$emit('timezone-selected', selected && selected[0] || this.defaultTZ);
        }
    },
    emits: ['timezone-selected']
});
</script>